// * IMPORTANT! This file is generated from _colors.scss. Do not modify this file directly.
export default {
  "gray50": "#fbfbfb",
  "gray100": "#efefef",
  "gray200": "#dadada",
  "gray300": "#c6c6c6",
  "gray400": "#afafb1",
  "gray500": "#99989d",
  "gray600": "#838289",
  "gray700": "#2e2e2e",
  "gray800": "#212121",
  "gray900": "#151515",
  "gray950": "#050505",
  "purple100": "#f7f6f9",
  "purple200": "#eee9f6",
  "purple300": "#ae8ff7",
  "purple500": "#8152ee",
  "purple600": "#6a4bb2",
  "purple700": "#432d77",
  "light": {
    "--text-color-primary": "#151515",
    "--text-color-secondary": "#838289",
    "--text-color-tertiary": "#99989d",
    "--text-color-accent": "#ae8ff7",
    "--text-color-inactive": "#99989d",
    "--text-color-reverse": "white",
    "--background-color-primary": "#fbfbfb",
    "--background-color-secondary": "white",
    "--background-color-tertiary": "#eee9f6",
    "--background-color-fourth": "#efefef",
    "--background-color-reverse": "black",
    "--background-color-accent": "#432d77",
    "--border-color-primary": "#dadada",
    "--border-color-secondary": "#efefef",
    "--border-color-tertiary": "#151515",
    "--border-color-accent": "#432d77",
    "--icon-color-primary": "#151515",
    "--icon-color-secondary": "#dadada",
    "--icon-color-tertiary": "#838289",
    "--icon-color-inactive": "#99989d",
    "--icon-color-reverse": "#fbfbfb",
    "--shadow-color-primary": "white",
    "--button-text-color-primary": "#fbfbfb",
    "--button-text-color-secondary": "#838289",
    "--button-background-color-primary": "#432d77",
    "--button-background-color-secondary": "white",
    "--button-background-color-secondary-hover": "#eee9f6",
    "--button-border-color-secondary": "#dadada",
    "--backdrop-background-color-primary": "rgba(251, 251, 251, 0.7)",
    "--chat-button-border-color-gradientOne": "transparent",
    "--chat-button-border-color-gradientTwo": "transparent",
    "--chat-button-border-color-gradientThree": "#432d77",
    "--chat-button-border-color-gradientFour": "#432d77",
    "--chat-button-border-color-gradientFive": "transparent",
    "--chat-button-border-color-gradientSix": "transparent",
    "--chat-button-background-color-gradientOne": "#432d77",
    "--chat-button-background-color-gradientTwo": "transparent"
  },
  "dark": {
    "--text-color-primary": "#fbfbfb",
    "--text-color-secondary": "#dadada",
    "--text-color-tertiary": "#838289",
    "--text-color-accent": "#ae8ff7",
    "--text-color-inactive": "#99989d",
    "--text-color-reverse": "black",
    "--background-color-primary": "#050505",
    "--background-color-secondary": "#151515",
    "--background-color-tertiary": "#212121",
    "--background-color-fourth": "#2e2e2e",
    "--background-color-reverse": "white",
    "--background-color-accent": "#8152ee",
    "--border-color-primary": "#2e2e2e",
    "--border-color-secondary": "#151515",
    "--border-color-tertiary": "#afafb1",
    "--border-color-accent": "#8152ee",
    "--icon-color-primary": "#fbfbfb",
    "--icon-color-secondary": "#dadada",
    "--icon-color-tertiary": "#838289",
    "--icon-color-inactive": "#99989d",
    "--icon-color-reverse": "#050505",
    "--shadow-color-primary": "black",
    "--button-text-color-primary": "#fbfbfb",
    "--button-text-color-secondary": "#99989d",
    "--button-background-color-primary": "#8152ee",
    "--button-background-color-secondary": "#151515",
    "--button-background-color-secondary-hover": "#212121",
    "--button-border-color-secondary": "#2e2e2e",
    "--backdrop-background-color-primary": "rgba(5, 5, 5, 0.7)",
    "--chat-button-border-color-gradientOne": "transparent",
    "--chat-button-border-color-gradientTwo": "transparent",
    "--chat-button-border-color-gradientThree": "#8152ee",
    "--chat-button-border-color-gradientFour": "#8152ee",
    "--chat-button-border-color-gradientFive": "transparent",
    "--chat-button-border-color-gradientSix": "transparent",
    "--chat-button-background-color-gradientOne": "#8152ee",
    "--chat-button-background-color-gradientTwo": "transparent"
  }
};